export default {
  index: [
    {
      path: '/freshOrder',
      component: resolve => require(['./freshOrderIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/order/_router.js